import Vue from 'vue';

// local state
const getDefaultState = () => {
	return {
		articles: []
	}
};

const state = getDefaultState()

const getters = {

};

const mutations = {
	updateArticles (state, articles) {
	    state.articles = articles
	},
	resetState (state) {
    	Object.assign(state, getDefaultState())
  	}
};

const actions = {
  resetState ({ commit }) {
    commit('resetState')
  },
};

export default {
  	namespaced: true,
  	state,
  	getters,
  	actions,
  	mutations,
};